import React from 'react';
import { connect, useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import Countdown from 'react-countdown';

import { rendererOne } from '../count-down';

import { findIndex } from '../../../utils';

import { addToWishlist } from '../../../actions/wishlistActions';
import { addPackToCartlist } from '../../../actions/cartlistActions';

function ProductNine( props ) {
    
    //const { product, isWishlist, onAddToCart, onToggleWishlist, showQuickView, onAddToCompare } = props;
    const { product, isWishlist, salle } = props;

    const dispatch = useDispatch();

    const cartlistHandler = () => {
        //if ( 0 !== product.stock )
            //onAddToCart( product, 1 );
        dispatch(addPackToCartlist( product.id, 1, false ));
    }

    const wishlistHandler = () => {
        /*if ( isWishlist ) {
            window.location = process.env.REACT_APP_PUBLIC_URL + '/shop/wishlist';
        } else {
            onToggleWishlist( product, isWishlist );
        }*/
        dispatch(addToWishlist( product.id ));
    }

    const quickViewHandler = () => {
        //showQuickView( product.id );
    }

    const addToCompareHandler = () => {
        //onAddToCompare( product );
    }

    return (
        product ?
            <div className="product text-center w-100">
                <figure className="product-media">
                    <span className="product-label label-sale">{ salle.nameFr }</span>

                    <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${product.id}` }>

                        {
                            salle.fileName &&
                                <LazyLoadImage
                                    alt="product"
                                    visibleByDefault={ true }
                                    src={ `${process.env.REACT_APP_API_URL}/uploads/sales/${salle.fileName}` }
                                    threshold={ 100 }
                                /> 
                        }
                        

                        { /*
                            <LazyLoadImage
                                alt="product"
                                visibleByDefault={ true }
                                src={ `${process.env.REACT_APP_API_URL}/uploads/sales/${product.fileName}` }
                                threshold={ 100 }
                                wrapperClassName="product-image-hover product-image"
                            />
                        */ }
                    </Link>

                    <div className="product-action-vertical">
                        <button
                            className={ `btn-product-icon btn-wishlist btn-expandable ${isWishlist ? 'added-to-wishlist' : 'remove-from-wishlist'}` }
                            onClick={ wishlistHandler }
                            title={ isWishlist ? "Go to wishlist" : "Ajouter au favorits" }
                        >
                            <span>{ isWishlist ? "go to wishlist" : "Ajouter au favorits" }</span>

                        </button>

                        {/*<button className="btn-product-icon btn-quickview" title="Quick view" onClick={ quickViewHandler }>
                            <span>Quick view</span>
                        </button>*/}

                    </div>

                    <div className="product-action">
                        <button className="btn-product btn-cart" title="ajouter au panier" 
                        onClick={ cartlistHandler }>
                            <span>ajouter au panier</span>
                        </button>
                    </div>
                </figure>

                <div className="product-body">
                    {/*<div className="product-cat">
                        <span className="mr-0">
                            <Link to="#">{ product.category[ 0 ] }</Link>
                        </span>
                    </div>*/}

                    <h3 className="product-title">
                        <Link to={ `${process.env.REACT_APP_PUBLIC_URL}/product/default/${product.id}` } >{ product.nameFr }</Link>
                    </h3>

                    {
                        0 === product.stock ?
                            <div className="product-price">
                                <span className="new-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                            </div> :

                            0 < product.discount ?
                                <div className="product-price">
                                    <span className="new-price">{ product.salePrice.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                                    <span className="old-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</span>
                                </div> :

                                <div className="product-price">{ product.price.toLocaleString( undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 } ) } MAD</div>
                    }

                    {/*<div className="ratings-container">
                        <div className="ratings">
                            <div className="ratings-val" style={ { width: product.ratings * 20 + '%' } }></div>
                        </div>
                        <span className="ratings-text">({ product.reviews } Reviews )</span>
                </div>*/}

                    <div className="product-countdown countdown-compact">
                        <Countdown date={ salle.endAt } renderer={ rendererOne } />
                    </div>
                </div>
            </div> : ''
    );
}

function mapStateToProps( state, ownprops ) {
    return {
        isWishlist: ( findIndex( state.wishlist.list, item => item.id === ownprops.product.id ) !== -1 ) ? true : false
    };
}

export default connect( mapStateToProps, { addToWishlist, addPackToCartlist } )( ProductNine );